import { CLASSES } from 'game/CLASSES';
import { TIERS } from 'game/TIERS';

//region TWW1
export const DEATH_KNIGHT_TWW1_ID = 1696;
export const DEMON_HUNTER_TWW1_ID = 1695;
export const DRUID_TWW1_ID = 1694;
export const EVOKER_TWW1_ID = 1693;
export const HUNTER_TWW1_ID = 1692;
export const MAGE_TWW1_ID = 1691;
export const MONK_TWW1_ID = 1690;
export const PALADIN_TWW1_ID = 1689;
export const PRIEST_TWW1_ID = 1688;
export const ROGUE_TWW1_ID = 1687;
export const SHAMAN_TWW1_ID = 1686;
export const WARLOCK_TWW1_ID = 1685;
export const WARRIOR_TWW1_ID = 1684;

type TWW1_TIER_GEAR_IDS =
  | typeof DEATH_KNIGHT_TWW1_ID
  | typeof DEMON_HUNTER_TWW1_ID
  | typeof DRUID_TWW1_ID
  | typeof EVOKER_TWW1_ID
  | typeof HUNTER_TWW1_ID
  | typeof MAGE_TWW1_ID
  | typeof MONK_TWW1_ID
  | typeof PALADIN_TWW1_ID
  | typeof PRIEST_TWW1_ID
  | typeof ROGUE_TWW1_ID
  | typeof SHAMAN_TWW1_ID
  | typeof WARLOCK_TWW1_ID
  | typeof WARRIOR_TWW1_ID;

export const TWW1_TIER_BY_CLASSES: Record<number, TWW1_TIER_GEAR_IDS> = {
  [CLASSES.DEATH_KNIGHT]: DEATH_KNIGHT_TWW1_ID,
  [CLASSES.DEMON_HUNTER]: DEMON_HUNTER_TWW1_ID,
  [CLASSES.DRUID]: DRUID_TWW1_ID,
  [CLASSES.EVOKER]: EVOKER_TWW1_ID,
  [CLASSES.HUNTER]: HUNTER_TWW1_ID,
  [CLASSES.MAGE]: MAGE_TWW1_ID,
  [CLASSES.MONK]: MONK_TWW1_ID,
  [CLASSES.PALADIN]: PALADIN_TWW1_ID,
  [CLASSES.PRIEST]: PRIEST_TWW1_ID,
  [CLASSES.ROGUE]: ROGUE_TWW1_ID,
  [CLASSES.SHAMAN]: SHAMAN_TWW1_ID,
  [CLASSES.WARLOCK]: WARLOCK_TWW1_ID,
  [CLASSES.WARRIOR]: WARRIOR_TWW1_ID,
};
// endregion

//region TWW2
export const DEATH_KNIGHT_TWW2_ID = 1867;
export const DEMON_HUNTER_TWW2_ID = 1868;
export const DRUID_TWW2_ID = 1869;
export const EVOKER_TWW2_ID = 1870;
export const HUNTER_TWW2_ID = 1871;
export const MAGE_TWW2_ID = 1872;
export const MONK_TWW2_ID = 1873;
export const PALADIN_TWW2_ID = 1874;
export const PRIEST_TWW2_ID = 1875;
export const ROGUE_TWW2_ID = 1876;
export const SHAMAN_TWW2_ID = 1877;
export const WARLOCK_TWW2_ID = 1878;
export const WARRIOR_TWW2_ID = 1879;

type TWW2_TIER_GEAR_IDS =
  | typeof DEATH_KNIGHT_TWW2_ID
  | typeof DEMON_HUNTER_TWW2_ID
  | typeof DRUID_TWW2_ID
  | typeof EVOKER_TWW2_ID
  | typeof HUNTER_TWW2_ID
  | typeof MAGE_TWW2_ID
  | typeof MONK_TWW2_ID
  | typeof PALADIN_TWW2_ID
  | typeof PRIEST_TWW2_ID
  | typeof ROGUE_TWW2_ID
  | typeof SHAMAN_TWW2_ID
  | typeof WARLOCK_TWW2_ID
  | typeof WARRIOR_TWW2_ID;

export const TWW2_TIER_BY_CLASSES: Record<number, TWW2_TIER_GEAR_IDS> = {
  [CLASSES.DEATH_KNIGHT]: DEATH_KNIGHT_TWW2_ID,
  [CLASSES.DEMON_HUNTER]: DEMON_HUNTER_TWW2_ID,
  [CLASSES.DRUID]: DRUID_TWW2_ID,
  [CLASSES.EVOKER]: EVOKER_TWW2_ID,
  [CLASSES.HUNTER]: HUNTER_TWW2_ID,
  [CLASSES.MAGE]: MAGE_TWW2_ID,
  [CLASSES.MONK]: MONK_TWW2_ID,
  [CLASSES.PALADIN]: PALADIN_TWW2_ID,
  [CLASSES.PRIEST]: PRIEST_TWW2_ID,
  [CLASSES.ROGUE]: ROGUE_TWW2_ID,
  [CLASSES.SHAMAN]: SHAMAN_TWW2_ID,
  [CLASSES.WARLOCK]: WARLOCK_TWW2_ID,
  [CLASSES.WARRIOR]: WARRIOR_TWW2_ID,
};
// endregion

//region TWW3
export const DEATH_KNIGHT_TWW3_ID = 1919;
export const DEMON_HUNTER_TWW3_ID = 1920;
export const DRUID_TWW3_ID = 1921;
export const EVOKER_TWW3_ID = 1922;
export const HUNTER_TWW3_ID = 1923;
export const MAGE_TWW3_ID = 1924;
export const MONK_TWW3_ID = 1925;
export const PALADIN_TWW3_ID = 1926;
export const PRIEST_TWW3_ID = 1927;
export const ROGUE_TWW3_ID = 1928;
export const SHAMAN_TWW3_ID = 1929;
export const WARLOCK_TWW3_ID = 1930;
export const WARRIOR_TWW3_ID = 1931;

type TWW3_TIER_GEAR_IDS =
  | typeof DEATH_KNIGHT_TWW3_ID
  | typeof DEMON_HUNTER_TWW3_ID
  | typeof DRUID_TWW3_ID
  | typeof EVOKER_TWW3_ID
  | typeof HUNTER_TWW3_ID
  | typeof MAGE_TWW3_ID
  | typeof MONK_TWW3_ID
  | typeof PALADIN_TWW3_ID
  | typeof PRIEST_TWW3_ID
  | typeof ROGUE_TWW3_ID
  | typeof SHAMAN_TWW3_ID
  | typeof WARLOCK_TWW3_ID
  | typeof WARRIOR_TWW3_ID;

export const TWW3_TIER_BY_CLASSES: Record<number, TWW3_TIER_GEAR_IDS> = {
  [CLASSES.DEATH_KNIGHT]: DEATH_KNIGHT_TWW3_ID,
  [CLASSES.DEMON_HUNTER]: DEMON_HUNTER_TWW3_ID,
  [CLASSES.DRUID]: DRUID_TWW3_ID,
  [CLASSES.EVOKER]: EVOKER_TWW3_ID,
  [CLASSES.HUNTER]: HUNTER_TWW3_ID,
  [CLASSES.MAGE]: MAGE_TWW3_ID,
  [CLASSES.MONK]: MONK_TWW3_ID,
  [CLASSES.PALADIN]: PALADIN_TWW3_ID,
  [CLASSES.PRIEST]: PRIEST_TWW3_ID,
  [CLASSES.ROGUE]: ROGUE_TWW3_ID,
  [CLASSES.SHAMAN]: SHAMAN_TWW3_ID,
  [CLASSES.WARLOCK]: WARLOCK_TWW3_ID,
  [CLASSES.WARRIOR]: WARRIOR_TWW3_ID,
};
// endregion

//region MID1
export const DEATH_KNIGHT_MID1_ID = 1978;
export const DEMON_HUNTER_MID1_ID = 1979;
export const DRUID_MID1_ID = 1980;
export const EVOKER_MID1_ID = 1981;
export const HUNTER_MID1_ID = 1982;
export const MAGE_MID1_ID = 1983;
export const MONK_MID1_ID = 1984;
export const PALADIN_MID1_ID = 1985;
export const PRIEST_MID1_ID = 1986;
export const ROGUE_MID1_ID = 1987;
export const SHAMAN_MID1_ID = 1988;
export const WARLOCK_MID1_ID = 1989;
export const WARRIOR_MID1_ID = 1990;

type MID1_TIER_GEAR_IDS =
  | typeof DEATH_KNIGHT_MID1_ID
  | typeof DEMON_HUNTER_MID1_ID
  | typeof DRUID_MID1_ID
  | typeof EVOKER_MID1_ID
  | typeof HUNTER_MID1_ID
  | typeof MAGE_MID1_ID
  | typeof MONK_MID1_ID
  | typeof PALADIN_MID1_ID
  | typeof PRIEST_MID1_ID
  | typeof ROGUE_MID1_ID
  | typeof SHAMAN_MID1_ID
  | typeof WARLOCK_MID1_ID
  | typeof WARRIOR_MID1_ID;

export const MID1_TIER_BY_CLASSES: Record<number, MID1_TIER_GEAR_IDS> = {
  [CLASSES.DEATH_KNIGHT]: DEATH_KNIGHT_MID1_ID,
  [CLASSES.DEMON_HUNTER]: DEMON_HUNTER_MID1_ID,
  [CLASSES.DRUID]: DRUID_MID1_ID,
  [CLASSES.EVOKER]: EVOKER_MID1_ID,
  [CLASSES.HUNTER]: HUNTER_MID1_ID,
  [CLASSES.MAGE]: MAGE_MID1_ID,
  [CLASSES.MONK]: MONK_MID1_ID,
  [CLASSES.PALADIN]: PALADIN_MID1_ID,
  [CLASSES.PRIEST]: PRIEST_MID1_ID,
  [CLASSES.ROGUE]: ROGUE_MID1_ID,
  [CLASSES.SHAMAN]: SHAMAN_MID1_ID,
  [CLASSES.WARLOCK]: WARLOCK_MID1_ID,
  [CLASSES.WARRIOR]: WARRIOR_MID1_ID,
};
// endregion

// region Common
export const TIER_BY_CLASSES: Record<number, Record<number, number>> = {
  [TIERS.TWW1]: TWW1_TIER_BY_CLASSES,
  [TIERS.TWW2]: TWW2_TIER_BY_CLASSES,
  [TIERS.TWW3]: TWW3_TIER_BY_CLASSES,
  [TIERS.MID1]: MID1_TIER_BY_CLASSES,
};

export type TIER_GEAR_IDS =
  | TWW1_TIER_GEAR_IDS
  | TWW2_TIER_GEAR_IDS
  | TWW3_TIER_GEAR_IDS
  | MID1_TIER_GEAR_IDS;
// endregion
